import axios, { AxiosResponse } from 'axios';
import { EditorialTemplate, EditorialType } from '../domain/domain';
import { getHeaders, BASE_URL } from './common';


export function getEditorialTemplates(selectedEditorialType: EditorialType): Promise<AxiosResponse<EditorialTemplate[]>> {
    return axios.get(BASE_URL + `/legal/editorial/templates/${selectedEditorialType}`, {headers: getHeaders()});
}

export function updateEditorialTemplate(editorialTemplate: EditorialTemplate): Promise<AxiosResponse<EditorialTemplate>> {
    return axios.put(BASE_URL + `/legal/editorial/templates/${editorialTemplate.id}`, editorialTemplate, {headers: getHeaders()});
}

export function updateEditorialTemplates(editorialTemplates: EditorialTemplate[]): Promise<AxiosResponse<EditorialTemplate[]>> {
    return axios.put(BASE_URL + `/legal/editorial/templates`, editorialTemplates, {headers: getHeaders()});
}

export function createEditorialTemplate(editorialTemplate: EditorialTemplate): Promise<AxiosResponse<EditorialTemplate>> {
    return axios.post(BASE_URL + `/legal/editorial/templates`, editorialTemplate, {headers: getHeaders()});
}

export function deleteEditorialTemplate(editorialTemplate: EditorialTemplate): Promise<AxiosResponse<string>> {
    return axios.delete(BASE_URL + `/legal/editorial/templates/${editorialTemplate.id}`, {headers: getHeaders()});
}